import { INVOICE_SERVICE, AVTALA_BACKEND } from "@/store/constants";

const ARTICLES = "/articles/"
const TEMPLATES = "/templates/"
const INVOICES = "/invoices/"

export default {
  namespaced: true,
  state: () => ({
    invoiceSearch: null,
  }),
  actions: {
    setInvoiceSearch({ commit }, query) {
      commit("setInvoiceSearch", query);
      return Promise.resolve(query);
    },
    getArticles({ dispatch }, query) {
      return new Promise(function (resolve, reject) {
        dispatch("API", INVOICE_SERVICE, { root: true })
          .then((api) =>
            api.get(
              `${ARTICLES}${query !== undefined ? "?query=" + query : ""}`
            )
          )
          .then((response) => resolve(response.data))
          .catch((err) => reject(err));
      });
    },
    getInvoiceTemplates({ dispatch }, { target }) {
      return new Promise(function (resolve, reject) {
        dispatch("API", INVOICE_SERVICE, { root: true })
          .then((api) =>
            api.get(`${TEMPLATES}?target=${encodeURIComponent(target)}`)
          )
          .then((response) => resolve(response.data))
          .catch((err) => reject(err));
      });
    },
    saveInvoiceTemplate({ dispatch }, { data }) {
      return new Promise(function (resolve, reject) {
        dispatch("API", INVOICE_SERVICE, { root: true })
          .then((api) => {
            if (data.id) {
              return api.put(TEMPLATES + encodeURIComponent(data.id), data);
            }
            return api.post(TEMPLATES, data);
          })
          .then((response) => resolve(response.data))
          .catch((err) => reject(err));
      });
    },
    deleteInvoiceTemplate({ dispatch }, { id }) {
      return new Promise(function (resolve, reject) {
        dispatch("API", INVOICE_SERVICE, { root: true })
          .then((api) => api.delete(TEMPLATES + encodeURIComponent(id)))
          .then((response) => resolve(response.data))
          .catch((err) => reject(err));
      });
    },
    triggerInvoiceTemplate({ dispatch }, id) {
      return new Promise(function (resolve, reject) {
        dispatch("API", AVTALA_BACKEND, { root: true })
          .then((api) =>
            api.post(`/contract/${encodeURIComponent(id)}/invoice`)
          )
          .then((response) => resolve(response.data))
          .catch((err) => reject(err));
      });
    },
    getInvoices({ dispatch }, { target }) {
      return new Promise(function (resolve, reject) {
        dispatch("API", INVOICE_SERVICE, { root: true })
          .then((api) =>
            api.get(`${INVOICES}queue?target=${encodeURIComponent(target)}`)
          )
          .then((response) => resolve(response.data))
          .catch((err) => reject(err));
      });
    },
    searchInvoices({ dispatch }, query) {
      return new Promise(function (resolve, reject) {
        dispatch("API", INVOICE_SERVICE, { root: true })
          .then((api) => api.post(`${INVOICES}queue/search`, query))
          .then((response) => resolve(response.data))
          .catch((err) => reject(err));
      });
    },
    getInvoice({ dispatch }, { id }) {
      return new Promise(function (resolve, reject) {
        dispatch("API", INVOICE_SERVICE, { root: true })
          .then((api) => api.get(`${INVOICES}queue/${encodeURIComponent(id)}`))
          .then((response) => resolve(response.data))
          .catch((err) => reject(err));
      });
    },
    updateInvoice({ dispatch }, data) {
      return new Promise(function (resolve, reject) {
        dispatch("API", INVOICE_SERVICE, { root: true })
          .then((api) =>
            api.put(`${INVOICES}queue/${encodeURIComponent(data.id)}`, data)
          )
          .then((response) => resolve(response.data))
          .catch((err) => reject(err));
      });
    },
    updateInvoiceStatus({ dispatch }, data) {
      return new Promise(function (resolve, reject) {
        dispatch("API", INVOICE_SERVICE, { root: true })
          .then((api) =>
            api.put(`${INVOICES}queue`, data)
          )
          .then((response) => resolve(response.data))
          .catch((err) => reject(err));
      });
    },
    deleteInvoice({ dispatch }, { id }) {
      return new Promise(function (resolve, reject) {
        dispatch("API", INVOICE_SERVICE, { root: true })
          .then((api) =>
            api.delete(`${INVOICES}queue/${encodeURIComponent(id)}`)
          )
          .then((response) => resolve(response.data))
          .catch((err) => reject(err));
      });
    },
  },
  mutations: {
    setInvoiceSearch(state, formData) {
      state.invoiceSearch = { ...formData };
    },
  },
  getters: {
    invoiceSearch(state) {
      return state.invoiceSearch;
    },
  },
};
